import { useProfile } from "Components/Hooks/UserHooks";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ICON_AGENCIES,
  ICON_CONTRACTS,
  ICON_INDIVIDUALS,
  ICON_MDAS,
  ICON_USERS,
} from "../common/constants";

const Navdata = () => {
  const history = useNavigate();
  const { userProfile } = useProfile();
  //state data
  const [isDashboard, setIsDashboard] = useState<boolean>(false);
  const [isDueDiligenceSearch, setIsDueDiligenceSearch] =
    useState<boolean>(false);
  const [isIndividuals, setIsIndividuals] = useState<boolean>(false);
  const [isPayments, setIsPayments] = useState<boolean>(false);
  const [isMDAs, setIsMDAs] = useState<boolean>(false);

  const [isReportingAgencies, setIsReportingAgencies] =
    useState<boolean>(false);
  const [isGovtRequests, setIsGovtRequests] = useState<boolean>(false);
  const [isReports, setIsReports] = useState<boolean>(false);
  const [isUsers, setIsUsers] = useState<boolean>(false);
  const [isAgencyDashboard, setIsAgencyDashboard] = useState<boolean>(false);
  const [isAgencyGovtRequests] = useState<boolean>(false);
  const [isAgencyData, setIsAgencyData] = useState<boolean>(false);
  const [isDataTypes, setIsDataTypes] = useState<boolean>(false);
  const [isAgencyUsers, setIsAgencyUsers] = useState<boolean>(false);
  const [isRegions, setIsRegions] = useState<boolean>(false);
  const [isAgencies, setIsAgencies] = useState<boolean>(false);
  const [isAdminOverlappingPayments, setIsAdminOverlappingPayments] =
    useState<boolean>(false);
  const [isLOAs, setIsLOAs] = useState<boolean>(false);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems: any = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("sub-items");
        const getID = document.getElementById(id) as HTMLElement;
        if (getID) getID.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "DueDiligenceSearch") {
      setIsDueDiligenceSearch(false);
    }
    if (iscurrentState !== "Payments") {
      setIsPayments(false);
    }
    if (iscurrentState !== "Inidviduals") {
      setIsIndividuals(false);
    }
    if (iscurrentState !== "MDAs") {
      setIsMDAs(false);
    }
    if (iscurrentState !== "AgencyDashboard") {
      setIsAgencyDashboard(false);
    }
    if (iscurrentState !== "AgencyUsers") {
      setIsAgencyUsers(false);
    }
    if (iscurrentState !== "AgencyData") {
      setIsAgencyData(false);
    }
    if (iscurrentState !== "Reports") {
      setIsReports(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isUsers,
    isAgencyDashboard,
    isAgencyData,
    isIndividuals,
    isPayments,
    isMDAs,
    isReportingAgencies,
    isGovtRequests,
    isAgencyGovtRequests,
    isAgencies,
    isAgencyGovtRequests,
    isLOAs,
  ]);

  const menuItems: any = [
    {
      label: "General",
      isHeader: true,
      checks: [{ resource: "payment", action: "find" }],
    },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      stateVariables: isDashboard,
      checks: [{ resource: "payment", action: "find" }],
      click: function (e: any) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "search",
      label: "Search",
      icon: "ri-search-eye-line",
      link: "/search",
      checks: [{ resource: "payment", action: "find" }],

      click: function (e: any) {
        e.preventDefault();
        setIsDueDiligenceSearch(!isDueDiligenceSearch);
        setIscurrentState("DueDiligenceSearch");
        updateIconSidebar(e);
      },
      stateVariables: isDueDiligenceSearch,
    },
    {
      id: "mdas",
      label: "Ministries (MDAs)",
      icon: ICON_MDAS,
      link: "/mdas",
      stateVariables: isMDAs,
      checks: [{ resource: "mda", action: "find" }],
      click: function (e: any) {
        e.preventDefault();
        setIsMDAs(!isMDAs);
        setIscurrentState("MDAs");
        updateIconSidebar(e);
      },
    },
    {
      id: "individuals",
      label: "Individual Recipients",
      icon: ICON_INDIVIDUALS,
      link: "/individuals",
      checks: [{ resource: "individual", action: "find" }],
      click: function (e: any) {
        e.preventDefault();
        setIsIndividuals(!isIndividuals);
        setIscurrentState("Inidviduals");
        updateIconSidebar(e);
      },
      stateVariables: isIndividuals,
    },
    {
      id: "payments",
      label: "Payments / Contracts",
      icon: ICON_CONTRACTS,
      link: "/payments",
      checks: [{ resource: "payment", action: "find" }],
      click: function (e: any) {
        e.preventDefault();
        setIsPayments(!isPayments);
        setIscurrentState("Payments");
        updateIconSidebar(e);
      },
      stateVariables: isPayments,
    },
    {
      id: "overlapping-payments",
      label: "Overlapping Payments",
      icon: "ri-file-list-line",
      link: "/overlapping-payments",
      checks: [{ resource: "overlapping-payment", action: "find" }],

      click: function (e: any) {
        e.preventDefault();
        setIsAdminOverlappingPayments(!isAdminOverlappingPayments);
        setIscurrentState("AdminOverlappingPayments");
        updateIconSidebar(e);
      },
      stateVariables: isAdminOverlappingPayments,
    },
    {
      id: "reporting-agencies",
      label: "Reporting Agencies",
      icon: ICON_AGENCIES,
      link: "/reporting-agencies",
      checks: [{ resource: "agency", action: "find" }],
      click: function (e: any) {
        e.preventDefault();
        setIsReportingAgencies(!isReportingAgencies);
        setIscurrentState("ReportingAgencies");
        updateIconSidebar(e);
      },
      stateVariables: isReportingAgencies,
    },
    {
      id: "loas",
      label: "LOAs",
      icon: "ri-newspaper-line",
      link: "/loas",
      checks: [
        { resource: "government-request", action: "find", controller: "loa" },
      ],
      click: function (e: any) {
        e.preventDefault();
        setIsLOAs(!isLOAs);
        setIscurrentState("LOAs");
        updateIconSidebar(e);
      },
      stateVariables: isLOAs,
    },
    {
      id: "govt-requests",
      label: "Government Requests",
      icon: "ri-send-plane-2-line",
      link: "/government-requests",
      checks: [{ resource: "government-request", action: "find" }],

      click: function (e: any) {
        e.preventDefault();
        setIsGovtRequests(!isGovtRequests);
        setIscurrentState("GovernmentRequests");
        updateIconSidebar(e);
      },
      stateVariables: isGovtRequests,
    },

    {
      id: "reports",
      label: "Reports",
      icon: "ri-bar-chart-2-line",
      link: "/#",
      checks: [{ resource: "payment", action: "find" }],
      click: function (e: any) {
        e.preventDefault();
        setIsReports(!isReports);
        setIscurrentState("Reports");
        updateIconSidebar(e);
      },
      stateVariables: isReports,
      subItems: [
        // {
        //   id: "cims-reports",
        //   label: "CIRT Report",
        //   link: "/reports/cims-reports",
        //   parentId: "reports",
        // },
        {
          id: "payment-categories-report",
          label: "Payment Categories Report",
          link: "/reports/payment-categories-report",
          parentId: "reports",
          checks: [{ resource: "payment", action: "find" }],
        },
        {
          id: "repoorting-agencies-report",
          label: "Reporting Agencies Report",
          link: "/reports/reporting-agencies-report",
          parentId: "reports",
          checks: [{ resource: "payment", action: "find" }],
        },
        // {
        //   id: "mdas-report",
        //   label: "MDAs Report",
        //   link: "/reports/mdas-report",
        //   parentId: "reports",
        // },
        {
          id: "gender-analysis-report",
          label: "Gender Analysis Report",
          link: "/reports/gender-analysis-report",
          parentId: "reports",
          checks: [{ resource: "payment", action: "find" }],
        },
        {
          id: "thematic-analysis-report",
          label: "Thematic Analysis Report",
          link: "/reports/thematic-analysis-report",
          parentId: "reports",
          checks: [{ resource: "payment", action: "find" }],
        },
      ],
    },

    {
      label: `${userProfile?.agency?.name} `,
      isHeader: true,
      checks: [
        { resource: "individual", action: "find", controller: "agency" },
        { resource: "payment", action: "find", controller: "agency" },
        {
          resource: "government-request",
          action: "find",
          controller: "agency",
        },

        { resource: "user-management", action: "find", controller: "agency" },
      ],
    },
    {
      id: "agency-dashboard",
      label: `${userProfile?.agency?.name} Dashboard`,
      icon: "ri-pie-chart-line",
      link: "/agency/agency-dashboard/agency",
      checks: [
        { resource: "individual", action: "find", controller: "agency" },
        { resource: "payment", action: "find", controller: "agency" },
        {
          resource: "government-request",
          action: "find",
          controller: "agency",
        },

        { resource: "user-management", action: "find", controller: "agency" },
      ],
      click: function (e: any) {
        e.preventDefault();
        setIsAgencyDashboard(!isAgencyDashboard);
        setIscurrentState("AgencyDashboard");
        updateIconSidebar(e);
      },
      stateVariables: isAgencyDashboard,
    },
    // {
    //   id: "agency-govt-requests",
    //   label: "Norway Govt Requests",
    //   icon: "ri-send-plane-2-line",
    //   link: "/agency/government-requests",
    //   checks: [{ resource: "agency", action: "find" }],
    //   click: function (e: any) {
    //     e.preventDefault();
    //     setIsAgencyGovtRequests(!isAgencyGovtRequests);
    //     setIscurrentState("AgencyGovtRequests");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isAgencyGovtRequests,
    // },
    {
      id: "agency-data",
      label: `${userProfile?.agency?.name} Data`,
      icon: "ri-database-2-line",
      link: "/#",
      checks: [
        { resource: "individual", action: "find", controller: "agency" },
        { resource: "payment", action: "find", controller: "agency" },
        {
          resource: "government-request",
          action: "find",
          controller: "agency",
        },
      ],
      click: function (e: any) {
        e.preventDefault();
        setIsAgencyData(!isAgencyData);
        setIscurrentState("AgencyData");
        updateIconSidebar(e);
      },
      stateVariables: isAgencyData,
      subItems: [
        {
          id: "agency-data-individuals",
          label: "Individuals",
          link: "/agency-data/individuals",
          parentId: "agency-data",
          checks: [
            { resource: "individual", action: "find", controller: "agency" },
          ],
        },
        {
          id: "agency-data-payments",
          label: "Payments",
          link: "/agency-data/payments",
          parentId: "agency-data",
          checks: [
            { resource: "payment", action: "find", controller: "agency" },
          ],
        },
        {
          id: "agency-data-government-requests",
          label: "Government Requests",
          link: "/agency/government-requests",
          parentId: "agency-data",
          checks: [
            {
              resource: "government-request",
              action: "find",
              controller: "agency",
            },
          ],
        },
        {
          id: "agency-data-overlapping-payments",
          label: "Overlapping Payments",
          link: "/agency/overlapping-payments",
          parentId: "agency-data",
          checks: [
            {
              resource: "overlapping-payment",
              action: "find",
              controller: "agency",
            },
          ],
        },
      ],
    },
    {
      id: "users",
      label: "Users",
      icon: "ri-group-line",
      link: "/agency/users",
      checks: [
        { resource: "user-management", action: "find", controller: "agency" },
      ],
      click: function (e: any) {
        e.preventDefault();
        setIsAgencyUsers(!isAgencyUsers);
        setIscurrentState("AgencyUsers");
        updateIconSidebar(e);
      },
      stateVariables: isUsers,
    },

    {
      label: "Site Administration",
      isHeader: true,
      checks: [{ resource: "agency", action: "create" }],
    },
    {
      id: "agencies",
      label: "Agencies",
      icon: "ri-earth-line",
      link: "/agencies",
      checks: [{ resource: "agency", action: "create" }],

      click: function (e: any) {
        e.preventDefault();
        setIsAgencies(!isAgencies);
        setIscurrentState("Agencies");
        updateIconSidebar(e);
      },
      stateVariables: isAgencies,
    },

    {
      id: "maps-regions",
      label: "Maps & Regions",
      icon: "ri-map-pin-line",
      link: "/#",
      checks: [{ resource: "country", action: "create" }],

      click: function (e: any) {
        e.preventDefault();
        setIsRegions(!isRegions);
        setIscurrentState("Regions");
        updateIconSidebar(e);
      },
      stateVariables: isRegions,
      subItems: [
        {
          id: "regions-countries",
          label: "Countries",
          link: "/countries",
          parentId: "maps-regions",
          checks: [{ resource: "country", action: "create" }],
        },
        {
          id: "regions",
          label: "Regions",
          link: "/regions",
          parentId: "maps-regions",
          checks: [{ resource: "region", action: "create" }],
        },
      ],
    },
    {
      id: "data-types",
      label: "Data Types",
      icon: "ri-database-2-line",
      link: "/#",
      checks: [
        { resource: "payment-category", action: "create" },
        { resource: "position-type", action: "create" },
      ],
      click: function (e: any) {
        e.preventDefault();
        setIsDataTypes(!isDataTypes);
        setIscurrentState("DataTypes");
        updateIconSidebar(e);
      },
      stateVariables: isDataTypes,
      subItems: [
        {
          id: "data-types-payment-categories",
          label: "Payment Categories",
          link: "/data-types/payment-categories",
          parentId: "data-types",
          checks: [{ resource: "payment-category", action: "create" }],
        },
        {
          id: "data-types-position-types",
          label: "Position Types",
          link: "/data-types/position-types",
          parentId: "data-types",
          checks: [{ resource: "position-type", action: "create" }],
        },
        {
          id: "data-types-thematic-areas",
          label: "Thematic Areas",
          link: "/data-types/thematic-areas",
          parentId: "data-types",
          checks: [{ resource: "thematic-area", action: "create" }],
        },
        {
          id: "data-types-sector",
          label: "Sectors",
          link: "/data-types/sectors",
          parentId: "data-types",
          checks: [{ resource: "sector", action: "create" }],
        },
      ],
    },
    {
      id: "users",
      label: "Users",
      icon: ICON_USERS,
      link: "/users",
      checks: [{ resource: "user-management", action: "create" }],
      click: function (e: any) {
        e.preventDefault();
        setIsUsers(!isUsers);
        setIscurrentState("Users");
        updateIconSidebar(e);
      },
      stateVariables: isUsers,
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
